"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mainColor = exports.borderColor = exports.small = exports.medium = exports.large = void 0;
// Mq
var large = "screen and (min-width: 64em)";
exports.large = large;
var medium = "screen and (min-width: 42em) and (max-width: 64em)";
exports.medium = medium;
var small = "screen and (max-width: 42em)";
exports.small = small;
var borderColor = "#dce6f0";
exports.borderColor = borderColor;
var mainColor = "#2c3e50";
exports.mainColor = mainColor;